import React, { useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import {
  MDBBtn,
  MDBCheckbox,
  MDBIcon,
  MDBInput,
  MDBModalFooter,
  MDBSelect,
} from "mdb-react-ui-kit";
import ReactDOM from "react-dom";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddExterNum from "../../../views/popups/misc/AddExterNum";
import { useTranslation } from "react-i18next";
import { validatePhoneNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import { normalizePhoneNumber } from "../../../apiclients/CommonUtils";
import { customSearch } from "../../CustomSearchUtil/CustomSearch";

// Default field names if none are provided
const DEFAULT_FIELD_NAMES = {
  hopType: "hop.hop_type",
  value: "hop.val",
  uniqueId: "hop.uniqueid",
  cidPassFlag: "hop.cid_pass_flag",
  cidPass: "hop.cid_pass",
  name: "hop.name",
  ph_num: "hop.phnumber",
};

function RouteOperator({
  operatorsList,
  operatorValue,
  fieldNames = DEFAULT_FIELD_NAMES,
  setExUpdate,
  setExDetails,
  externError,
  setExternError,
  calleridFlag,
  isLoading,
  setisLoading,
  AddExternalNumber,
  setAddExternalNumber,
  cidPassValue,
  aaflag,
}) {
  const {
    setValue,
    watch,
    control,
    register,
    formState: { errors },
    clearErrors,
    // unregister,
  } = useFormContext();

  const navigate = useNavigate();
  const [userList, setUserList] = useState([]);
  const [callerIDList, setCallerIDList] = useState([]);
  const [hgList, setHgList] = useState([]);
  const { t, i18n } = useTranslation();

  // Operator type constants (fixed)
  const OPERATOR_TYPES = {
    Users: 2,
    "Hunt Groups": 1,
    ...(!aaflag && { "External Numbers": 3 }),
  };

  useEffect(() => {
    if (!aaflag) fetchData();
  }, []);

  async function fetchData() {
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["callerid_list"],
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id not found`);
      navigate("/");
    }
    setCallerIDList(tdata?.misc?.callerid_list ?? []);
  }

  useEffect(() => {
    if (operatorsList && Object.entries(operatorsList).length > 0) {
      setUserList(operatorsList?.user ?? []);
      setHgList(operatorsList?.group ?? []);
    }
  }, [operatorsList]);

  useEffect(() => {
    if (operatorValue && Object.entries(operatorValue).length > 0) {
      if (operatorValue.hoptype === 3) {
        setSelectedValue("External Numbers");
        setSelectedType("External Numbers");
      } else {
        setSelectedValue(
          operatorValue.title +
          "" +
          (operatorValue.extension ? ` : ${operatorValue.extension}` : "")
        );
      }
    } else {
      setSelectedValue(null);
    }
  }, [operatorValue]);

  const dummyData = {
    Users: userList,
    "Hunt Groups": hgList,
    ...(!aaflag && { "External Numbers": [] }),
  };

  const [selectedType, setSelectedType] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const toggleShow15 = () => setAddExternalNumber(!AddExternalNumber);
  const addUserRef = useRef(null);

  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });

  function handleClick() {
    addUserRef.current.click();
  }

  const dropdownRef = useRef();
  const portalDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        portalDropdownRef.current &&
        !portalDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMainTypeClick = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedType(type);

    if (dummyData[type].length === 0) {
      setSelectedValue(type);
      setIsDropdownOpen(false);
    } else {
      setSearchTerm("");
    }
    if (type === "External Numbers" && operatorValue.hoptype !== 3) {
      toggleShow15();
    } else {
      setValue(fieldNames.hopType, OPERATOR_TYPES[type], { shouldDirty: true });
    }
  };

  const handleBack = () => {
    setSelectedType(null);
    setSearchTerm("");
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedValue(null);
    setSelectedType(null);
    setSearchTerm("");
    setIsDropdownOpen(true);
    setValue(fieldNames.hopType, 0, { shouldDirty: true });
    setValue(fieldNames.value, "", { shouldDirty: true });
    setValue(fieldNames.uniqueId, "", { shouldDirty: true });
    setValue(fieldNames.cidPassFlag, true, { shouldDirty: true });
    setValue(fieldNames.cidPass, "", { shouldDirty: true });
    setValue(fieldNames.name, "", { shouldDirty: true });
  };

  let filteredOptions =

    selectedType
      ? customSearch(
        dummyData[selectedType],
        searchTerm,
        ["title", "extensions"] // search in both title and extensions
      )
    : [];

  useEffect(() => {
    if (isDropdownOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const dropdownHeight = 300; // Estimate or measure actual dropdown height

      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // Decide whether to open upward
      setOpenUpward(spaceBelow < dropdownHeight && spaceAbove > dropdownHeight);

      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isDropdownOpen]);

  const handleOperatorSelect = (item) => {
    setSelectedValue(
      item.title + "" + (item.extensions ? ` : ${item.extensions}` : "")
    );
    setIsDropdownOpen(false);
    const { id, agentid, code } = item;
    setValue(
      fieldNames.hopType,
      id ? OPERATOR_TYPES.Users : OPERATOR_TYPES["Hunt Groups"],
      { shouldDirty: true }
    );
    setValue(
      fieldNames.value,
      id ? (aaflag ? agentid : id) : aaflag ? code + "" : code,
      {
        shouldDirty: true,
      }
    );
    // setValue(fieldNames.uniqueId, id ?? code, { shouldDirty: true });
    // setValue(fieldNames.title, item.title, { shouldDirty: true });
  };

  // Helper function to get error message from nested errors object
  const getError = (fieldPath) => {
    const parts = fieldPath.split(".");
    let result = errors;
    for (const part of parts) {
      if (!result) return undefined;
      result = result[part];
    }
    return result?.message;
  };


  useEffect(() => {
    const handleScroll = (event) => {
      if (!isDropdownOpen) return;
      if (
        dropdownRef.current?.contains(event.target) ||
        portalDropdownRef.current?.contains(event.target)
      ) {
        return;
      }
      setIsDropdownOpen(false);
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [isDropdownOpen]);



  return (
    <>
      <Controller
        name={fieldNames.hopType}
        control={control}
        rules={{
          validate: (value) => {
            const destinationValue = watch(fieldNames.value);
            const destinationType = fieldNames.hopType;
            if (
              (aaflag && !(!value || value === 0) && !destinationValue) ||
              (!aaflag && (!value || value === 0 || !selectedValue))
            ) {
              return aaflag
                ? "Operator is required"
                : "Human Operator is required";
            }
            return true;
          },
        }}
        render={({ field }) => (
          <>
            <div className="custom-selector w-100" ref={dropdownRef}>
              <div
                className="custom-selector-box form-select position-relative text-left"
                onClick={(e) => {
                  clearErrors(fieldNames.hopType);
                  if (!aaflag) setSelectedValue(null);
                  setSelectedType(null);
                  setSearchTerm("");
                  // setIsDropdownOpen(!isDropdownOpen);
                  setIsDropdownOpen(!isDropdownOpen);
                }}
              >
                {selectedValue ||
                  (aaflag ? "Select Operator" : "Select Human Operator")}
                {/* {selectedValue && (
                  <div
                    onClick={handleClear}
                    className="cursor-pointer bg-danger bg-opacity-25 border border-danger border-2 rounded-2 px-2 py-1 d-inline clear-btn position-absolute top-50 translate-middle m-0"
                    style={{ right: "20px" }}
                  >
                    <MDBIcon fas icon="times" />
                  </div>
                )} */}
              </div>
              {isDropdownOpen &&
                ReactDOM.createPortal(
                  <div
                    className="custom-selector-dropdown"
                    ref={portalDropdownRef}
                    style={{
                      position: "absolute",
                      top: openUpward ? undefined : dropdownPosition.top,
                      bottom: openUpward
                        ? window.innerHeight - dropdownPosition.top
                        : undefined,
                      left: dropdownPosition.left,
                      width: dropdownPosition.width,
                      zIndex: 9999,
                    }}
                  >
                    <div className="custom-selector-dropdown">
                      {!selectedType ? (
                        <>
                          <div className="custom-selector-options">
                            {Object.keys(dummyData).map((type) => (
                              <div
                                key={type}
                                className="custom-selector-option"
                                onClick={(e) => {
                                  // field.onChange(OPERATOR_TYPES[type]);
                                  handleMainTypeClick(e, type);
                                }}
                              >
                                {type}
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <>
                          {OPERATOR_TYPES[selectedType] &&
                            OPERATOR_TYPES[selectedType] !==
                              OPERATOR_TYPES["External Numbers"] && (
                              <>
                                <div className="custom-selector-suboptions">
                                  <div className="top-bar">
                                    <input
                                      autoFocus
                                      type="text"
                                      placeholder={`Search ${selectedType}`}
                                      value={searchTerm}
                                      onChange={(e) =>
                                        setSearchTerm(e.target.value)
                                      }
                                    />
                                    {searchTerm && (
                                      <MDBIcon
                                        fas
                                        icon="times"
                                        className="px-2 close-icon"
                                        color="danger"
                                        onClick={() => setSearchTerm("")}
                                      />
                                    )}
                                  </div>
                                  <div className="suboptions-list">
                                    {filteredOptions.length > 0 ? (
                                      filteredOptions.map((item) => (
                                        <div
                                          key={item.extensions}
                                          className="custom-selector-option"
                                          onClick={() => {
                                            handleOperatorSelect(item);
                                          }}
                                        >
                                          {item.title}
                                          {item.extensions
                                            ? ` : ${item.extensions}`
                                            : ""}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="custom-selector-option">
                                        No results found
                                      </div>
                                    )}
                                  </div>
                                  <MDBModalFooter className="py-2 pe-2">
                                    <MDBBtn
                                      size="sm"
                                      className="back-btn"
                                      onClick={handleBack}
                                    >
                                      Back
                                    </MDBBtn>
                                  </MDBModalFooter>
                                </div>
                              </>
                            )}
                        </>
                      )}
                    </div>
                  </div>,
                  document.body
                )}
            </div>
            {getError(fieldNames.hopType) && (
              <p className="text-danger">{getError(fieldNames.hopType)}</p>
            )}
          </>
        )}
      />
      {selectedType === "External Numbers" &&
        dummyData["External Numbers"].length === 0 && (
          <>
            <div className="mt-3">
              <MDBInput
                type="text"
                placeholder="Enter Name"
                {...register(fieldNames.name, {
                  required: "Name should not be empty",
                })}
              />
              {getError(fieldNames.name) && (
                <p className="text-danger">{getError(fieldNames.name)}</p>
              )}
              <MDBInput
                type="text"
                className="mt-3"
                placeholder="Enter External Number"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register(fieldNames.ph_num, {
                  // onChange: (e) =>
                  // setValue(fieldNames.uniqueId, e.target.value, {
                  //   shouldDirty: true,
                  // }),
                  required: "External Number is required",
                  validate: validatePhoneNumber,
                  onChange: normalizePhoneNumber,
                })}
              />
              {getError(fieldNames.ph_num) && (
                <p className="text-danger">{getError(fieldNames.ph_num)}</p>
              )}

              <div className="d-flex align-items-center justify-content-between mt-2">
                <label htmlFor="CheckBox1" className="fw-bold">
                  Caller ID Pass Through
                </label>
                <MDBCheckbox
                  name="CheckBox1"
                  id="CheckBox1"
                  checked={watch(fieldNames.cidPassFlag)}
                  onChange={(e) => {
                    setValue(fieldNames.cidPassFlag, e.target.checked, {
                      shouldDirty: true,
                    });
                    if (e.target.checked) {
                      // setValue(fieldNames.cidPass, "-1", { shouldDirty: true });
                      // unregister(fieldNames.cidPass);
                    }
                  }}
                />
              </div>
              <Controller
                name={fieldNames.cidPass}
                control={control}
                rules={{
                  validate: (value) => {
                    if (watch(fieldNames.cidPassFlag)) {
                      return true;
                    }

                    if (value === -1) {
                      return "Caller ID is required";
                    }

                    return validatePhoneNumber(value);
                  },
                }}
                render={({ field }) => (
                  <>
                    <MDBSelect
                      disabled={watch(fieldNames.cidPassFlag)}
                      name={fieldNames.cidPass}
                      value={
                        watch(fieldNames.cidPassFlag)
                          ? "-1"
                          : watch(fieldNames.cidPass) || "-1"
                      }
                      search
                      onChange={(e) => {
                        if (
                          e &&
                          e.value &&
                          e.value !== cidPassValue &&
                          e.value !== "-1"
                        ) {
                          // field.onChange(e.value);
                          clearErrors(fieldNames.cidPass);
                          setValue(fieldNames.cidPass, e.value, {
                            shouldDirty: true,
                          });
                        }
                      }}
                      data={[
                        { value: "-1", text: "Choose Caller ID" },
                        ...callerIDList?.map((item) => ({
                          value: item.phnum,
                          text: item.addl_info,
                        })),
                      ]}
                    />
                    {getError(fieldNames.cidPass) && (
                      <p className="text-danger">
                        {getError(fieldNames.cidPass)}
                      </p>
                    )}
                  </>
                )}
              />
            </div>
            {AddExternalNumber && (
              <PopupLoaderNew
                size="md"
                title={t("addExternal")}
                content={
                  <AddExterNum
                    setExDetails={setExDetails}
                    setExUpdate={setExUpdate}
                    onClose={toggleShow15}
                    externError={externError}
                    setExternError={setExternError}
                    callerids={callerIDList}
                    calleridFlag={calleridFlag}
                    ref={addUserRef}
                    setIsloading={setisLoading}
                  />
                }
                onShow={setAddExternalNumber}
                onClose={toggleShow15}
                onSave={handleClick}
                isloading={isLoading}
                flag={1}
              />
            )}
          </>
        )}
    </>
  );
}

export default RouteOperator;
